/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Billing_Error_Mode_RequiredInputs */



/**
* | output |
* | --- |
* | "The accumulated history changed while this dialog was open. Close it, reopen it to see the current figures, and choose again." |
*
* @param {Partner_Admin_Billing_Error_Mode_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_billing_error_mode_required = /** @type {((inputs?: Partner_Admin_Billing_Error_Mode_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Billing_Error_Mode_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die aufgelaufene Historie hat sich geändert, während dieser Dialog offen war. Bitte schließen, erneut öffnen, um die aktuellen Zahlen zu sehen, und neu entscheiden.")
	return /** @type {LocalizedString} */ ("The accumulated history changed while this dialog was open. Close it, reopen it to see the current figures, and choose again.")
});